import $ from "jquery";
import {showModal} from "./support/show-modal";
import {loaderShow, loaderHide} from "./loader";
import {GetPostcodeLocation} from "./get-postcode-location";

const ukPostcodeRegex = new RegExp(/^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/);
let _submitting = false;
let buttonText = '';

function markAsSubmitting(form) {
    _submitting = true;
    const submitButton = form.find('[type="submit"]');
    buttonText = submitButton.text();
    submitButton.text('Please wait...');
    submitButton.prop('disabled', true);
}

function unmarkAsSubmitting(form) {
    _submitting = false;
    const submitButton = form.find('[type="submit"]');
    submitButton.text(buttonText);
    submitButton.prop('disabled', false);
}

function handleForm(form) {
    const data = form.serialize();
    $.post(form.attr("action"), data, function (response) {
        const modal = $('#delivery-address-modal');
        resetValidationErrors();

        let redirectUrl = window.location.href;
        let type = "warning";
        let message = "";
        if (response.success) {
            redirectUrl = response.redirectUrl;
            window.location = redirectUrl;
            return;
        } else {
            unmarkAsSubmitting(form);
            if (!response.reload) {
                redirectUrl = response.redirectUrl;
            }

            message = response.message;
            type = (response.reload || response.redirectUrl) ? "warning" : "danger";
        }
        showMessage(message, type);
        if ((response.reload || response.redirectUrl)) {
            modal.find('[data-normal-footer]').addClass('d-none');
            modal.find('[data-continue-footer]').removeClass('d-none');
            modal.find('[data-continue-footer] a').attr('href', redirectUrl);
            modal.find('[delivery-address-data-fields]').addClass('d-none');
            modal.find('[delivery-address-data-search]').addClass('d-none');
        }
    }).fail(function () {
        unmarkAsSubmitting(form);
    }).always(function () {
        loaderHide(form.closest(".modal-content"));
    });

}

async function setCoordinates(form, postcode, key) {
    const result = await GetPostcodeLocation(postcode, key);
    if (result.success) {
        form.find('input[name="Postcode"]').val(result.postcode);
        form.find('input[name="Latitude"]').val(result.latitude);
        form.find('input[name="Longitude"]').val(result.longitude);
    } else {
        showMessage(result.error, "danger");
    }
    return result.success;
}

function validatePostcode(postcode) {
    return $.post('/PostCode/ValidatePostCode', { postcode });
}

export function initDeliveryPostcode() {
    $(document).on("click", "[data-set-delivery-postcode]", function (event) {
        event.preventDefault();
        const button = $(this);

        const context = button.parents('[data-set-delivery-postcode-context]');
        const quantity = context.find('[data-set-delivery-postcode-quantity]').val();
        const variantId = context.find('[data-set-delivery-postcode-id]').val();
        const makeItemDelivery = context.find('[data-set-delivery-postcode-make-item-delivery]').val();
        const postcodeOnly = button.data('set-delivery-postcode-only');

        const modal = $('#delivery-address-modal');

        resetValidationErrors();

        if (!postcodeOnly) {
            modal.find('[name="Quantity"]').val(quantity);
            modal.find('[name="VariantId"]').val(variantId);
            modal.find('[name="MakeItemDelivery"]').val(makeItemDelivery);
        }

        showModal(modal.get(0));
        const form = $('[data-set-delivery-postcode-form]');
        form.submit(async function (event) {
            event.preventDefault();
            if (_submitting) {
                return false;
            }
            markAsSubmitting(form);
            loaderShow(form.closest(".modal-content"));
            resetValidationErrors();
            const postcode = form.find('#searchAddress').val().trim();
            if (ukPostcodeRegex.test(postcode.toUpperCase())) {
                const key = $('[data-loqate-key]').data('loqate-key');
                const success = await setCoordinates(form, postcode, key);
                modal.find('[data-set-delivery-postcode-submit]').prop('disabled', false);
                if (!success) {
                    modal.find('[data-set-delivery-postcode-submit]').prop('disabled', true);
                    showMessage("Please enter a valid UK postcode.", "danger");
                    loaderHide(form.closest(".modal-content"), () => {
                        unmarkAsSubmitting(form);
                    });
                } else {
                    validatePostcode(postcode).done(function (response) {
                        if (response.isValid) {
                            handleForm(form);
                        } else {
                            showMessage(response.errorMessage || "Sorry we only delivery to mainland UK postcodes.", "danger");
                            loaderHide(form.closest(".modal-content"), () => {
                                unmarkAsSubmitting(form);
                            });
                        }
                    }).fail(function () {
                        showMessage("Error validating postcode.", "danger");
                        loaderHide(form.closest(".modal-content"), () => {
                            unmarkAsSubmitting(form);
                        });
                    });
                }
            } else {
                showMessage("Please enter a valid UK postcode.", "danger");
                loaderHide(form.closest(".modal-content"), () => {
                    unmarkAsSubmitting(form);
                });
            }
        });
    });
}

function resetValidationErrors() {
    const modal = $('#delivery-address-modal');
    modal.find('.alert').addClass('d-none');
    modal.find('[data-normal-footer]').removeClass('d-none');
    modal.find('[data-continue-footer]').addClass('d-none');
}

function showMessage(message, type = "warning") {
    const modal = $('#delivery-address-modal');
    let validationSummaryErrors = modal.find('.alert');
    validationSummaryErrors.attr('class', 'alert');
    validationSummaryErrors.addClass('alert-' + type);

    validationSummaryErrors.html(`${message}`);
}